import React from "react";

const F = "'Montserrat',sans-serif";

/** Computed style object for a filter <select> based on its active/disabled state.
 *  Export this to style third-party select wrappers (e.g. EventSelect) that accept a style prop. */
export const filterSelectStyle = (active, disabled = false) => ({
  padding: "7px 10px",
  borderRadius: 8,
  fontSize: 11,
  fontFamily: F,
  outline: "none",
  cursor: disabled ? "default" : "pointer",
  opacity: disabled ? 0.45 : 1,
  border: `1px solid ${active ? "#F3A78C" : "#D8DADC"}`,
  background: active ? "#FCEBE5" : "#fff",
  color: active ? "#E8431A" : "#818084",
  fontWeight: active ? 700 : 400,
});

/** Horizontal filter row shared across all pages. */
export function FilterBar({ children, style }) {
  return (
    <div style={{
      padding: "10px 28px",
      background: "#FAFAFA",
      borderBottom: "1px solid #D8DADC",
      display: "flex",
      gap: 8,
      alignItems: "center",
      flexWrap: "wrap",
      flexShrink: 0,
      ...style,
    }}>
      {children}
    </div>
  );
}

/** A <select> that applies active/inactive filter styles automatically. */
export function FilterSelect({ value, onChange, active, disabled, children, style }) {
  return (
    <select
      value={value}
      onChange={onChange}
      disabled={disabled}
      style={{ ...filterSelectStyle(active, disabled), ...style }}
    >
      {children}
    </select>
  );
}

/** The ✕ Clear button consistent across all filter bars. */
export function FilterClear({ onClick }) {
  return (
    <button
      onClick={onClick}
      style={{
        padding: "7px 12px",
        borderRadius: 8,
        border: "1px solid #fbd5d5",
        background: "#fff",
        color: "#C1121F",
        fontSize: 10,
        fontWeight: 700,
        cursor: "pointer",
        fontFamily: F,
      }}
    >
      ✕ Clear
    </button>
  );
}

/** Flex spacer — pushes subsequent items (e.g. Export button) to the right. */
export function FilterSpacer() {
  return <div style={{ flex: 1 }} />;
}
